import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {PessoaDetalhes} from "../../../models/pessoa-detalhes";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {AtendimentoService} from "../../../services/atendimento.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ClienteService} from "../../../services/cliente.service";
import Swal from "sweetalert2";
import {TipoDocumentoCliente} from "../../../gerais/models/tipo-documento-cliente";
import {CadastrosGeraisService} from "../../../services/cadastros-gerais.service";

@Component({
    selector: 'app-detalhes-cliente',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent implements OnChanges {
  @Input() clienteId: number;
  @Input() habilitarEdicao = false;
  @Output() fecharModalCalled = new EventEmitter();
  @Output() atualizarListaCalled = new EventEmitter();

  cliente = new PessoaDetalhes();
  formAlterarDados: FormGroup;
  loading = false;
  listaTipoDocumento: TipoDocumentoCliente[] = [];
  mascaraDocumento = '';

  constructor(private toastr: ToastrService,
              private route: ActivatedRoute,
              private clienteService: ClienteService,
              private formBuilder: FormBuilder,
              private geraisService: CadastrosGeraisService,
              private router: Router) {
    this.formConstruir();
    this.listarTipoDocumentoCliente();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clienteId'] && this.clienteId > 0) {
      this.buscarPorId(this.clienteId);
    }
  }

  fecharModal() {
    this.fecharModalCalled.emit();
  }

  private listarTipoDocumentoCliente(){
    this.geraisService.selecionarListaTipoDocumentosCliente().subscribe(response => {
      if(response.sucesso){
        this.listaTipoDocumento = response.dados;
      }
    })
  }

  salvarAlteracoes(){
    Swal.fire({
      title: 'Deseja realmente alterar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModelo();
        this.clienteService.alterar(this.cliente).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Cliente alterado com sucesso");
            this.atualizarListaCalled.emit();
            this.buscarPorId(this.clienteId);
          } else {
            this.toastr.error("Erro ao alterar o cliente - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar o cliente - " + error);
        });
        this.loading = false;
      }
    });
  }

  voltar(){
    this.router.navigate(['/cadastro/cliente']);
  }

  desativar(){
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModelo();
        this.clienteService.desativar(this.cliente.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Cliente deletado com sucesso");
            this.atualizarListaCalled.emit();
            this.buscarPorId(this.clienteId);
          } else {
            this.toastr.error("Erro ao deletado o cliente - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao deletado o cliente - " + error);
        });
        this.loading = false;
      }
    });
  }

  private formConstruir(){
    this.formAlterarDados = this.formBuilder.group({
      nome: [this.cliente.nome, [Validators.required]],
      tipoDocumento: [this.cliente.tipoDocumento, [Validators.required]],
      documento: [this.cliente.documento, [Validators.required]],
      telefone: [this.cliente.telefone, [Validators.required]]
    });
  }

  private buscarPorId(id: number) {
    this.clienteService.selecionarPorId(id).subscribe(response => {
      if(response.sucesso)
      {
        this.cliente = response.dados;
        this.preencherFormulario();
      }
    });
  }

  private preencherFormulario(){
    this.formAlterarDados.patchValue({
      nome: this.cliente.nome,
      documento: this.cliente.documento,
      tipoDocumento: this.cliente.tipoDocumento,
      telefone: this.cliente.telefone
    });
    this.definirMascaraDocumento();
  }

  definirMascaraDocumento() {
    const tipoDocumentoId = this.formAlterarDados.controls['tipoDocumento'].value;
    const tipoDocumento = this.listaTipoDocumento.find(x => x.id === tipoDocumentoId);

    if (tipoDocumento) {
      if (tipoDocumento.descricao.toUpperCase().includes("CPF")) {
        this.mascaraDocumento = "000.000.000-00";
      } else if (tipoDocumento.descricao.toUpperCase().includes("CNPJ")) {
        this.mascaraDocumento = "00.000.000/0000-00";
      } else if (tipoDocumento.descricao.toUpperCase().includes("RG")) {
        this.mascaraDocumento = "00.000.000-0";
      } else {
        this.mascaraDocumento = "";
      }
    }
  }

  private preencherModelo(){
    this.cliente.nome = this.formAlterarDados.controls['nome'].value;
    this.cliente.documento = this.formAlterarDados.controls['documento'].value;
    this.cliente.tipoDocumento = this.formAlterarDados.controls['tipoDocumento'].value;
    this.cliente.telefone = this.formAlterarDados.controls['telefone'].value;
  }
}
